<template>
  <div class="intentionOrder" >
    <el-tabs  type="border-card" v-model="activeName">
      <el-tab-pane label="Initiate Order" name="one">
        <OrderList falg='1' :orderData="orderData1"/>
      </el-tab-pane>
      <el-tab-pane v-if="user.authent*1" label="Send Order" name="two" >
        <OrderList falg='0' :orderData="orderData2" @initReceived='initReceived'/>
      </el-tab-pane>
    </el-tabs>
    
  </div>
</template>

<script>
import OrderList from "./orderList";
import { reqMyOrderTo, reqMyOrderGet } from "../../../../api";
import { mapState } from "vuex";
export default {
  components:{
    OrderList,
  },
  data(){
    return{
      activeName:'one',
      orderData1:{
        form:[
          {title:'Specification/model',key:'pro_specification_type'},
          {title:'Quantity',key:'amount'},
          {title:'Delivery Address',key:'address'},
          {title:'Unit price',key:'pro_price'},
          {title:'Order Time',key:'ctime'},
        ],
        column:[
          {title:'Product Picture',key:'img_url',falg:0,width:110},
          {title:'Product Name',key:'proname_en',falg:1,width:'auto'},
          {title:'Exhibitor Name',key:'corpname_en',falg:1,width:'auto'},
          {title:'Order Status',key:'status',falg:2,width:120},
        ],
        list:[]
      },
      orderData2:{
        form:[
          {title:'Product Name',key:'proname_en'},
          {title:'Quantity',key:'amount'},
          {title:'Delivery Address',key:'address'},
          {title:'Tel',key:'mobile'},
          {title:'Order Time',key:'ctime'},
          {title:'email',key:'email'},
        ],
        column:[
          {title:'Profile Picture',key:'img',falg:0,width:110},
          {title:'Profile Picture',key:'name',falg:1,width:'auto'},
          {title:'Profile Picture',key:'corpname',falg:1,width:'auto'},
          {title:'Order Status',key:'status',falg:3,width:120},
        ],
        list:[]
      }
    }
  },
  mounted(){
    this.initHair()
    this.initReceived()
  },
  methods:{
    async initHair(){
      const response = await reqMyOrderTo()
      console.log(response);
      if (response.code*1==2) {
        // this.orderData1.list=response.reslist
        this.sorting(response.reslist,0)
      }
    },
    async initReceived(){
      const response = await reqMyOrderGet()
      console.log(response);
      if (response.code*1==2) {
        // this.orderData1.list=response.reslist
        this.sorting(response.reslist,1)
      }
    },
    sorting(arr,key){
      arr.forEach(item => {
        if (!item.pro_price) {
          item.pro_price='Negotiate'
        }
        if (!item.name) {
          item.name=item.nickname
        }
      });
      if (key) {
        this.orderData2.list=arr
      }else{
        this.orderData1.list=arr
      }
    },
  },
  computed:{
    ...mapState({
      user:state=>state.user.user,
    })
  },
}
</script>

<style scoped>
  .intentionOrder{
    max-width: 1200px;
    margin: auto;
  }
</style>